import type { JudgmentGrade } from '@/types';
import { SCORE_POINTS, COMBO_MULTIPLIER_THRESHOLDS } from '@/game/config/GameConfig';

/** Pure scoring math, deliberately decoupled from rendering/scenes so it can be unit
 * tested and reused (e.g. by the results screen) without touching Phaser. */

export function computeAccuracy(perfectCount: number, goodCount: number, missCount: number): number {
  const total = perfectCount + goodCount + missCount;
  if (total === 0) return 0;
  const earned = perfectCount * SCORE_POINTS.perfect + goodCount * SCORE_POINTS.good;
  const max = total * SCORE_POINTS.perfect;
  return (earned / max) * 100;
}

export function computeComboMultiplier(combo: number): number {
  for (const tier of COMBO_MULTIPLIER_THRESHOLDS) {
    if (combo >= tier.combo) return tier.multiplier;
  }
  return 1;
}

/** Points awarded for a single judgment, including the combo multiplier that applies
 * given the combo count *after* this hit is counted (misses always score zero and
 * never receive a multiplier). */
export function computePointsForGrade(grade: JudgmentGrade, comboAfterHit: number): number {
  const base = SCORE_POINTS[grade];
  if (base === 0) return 0;
  return Math.round(base * computeComboMultiplier(comboAfterHit));
}

export function computeStarRating(accuracy: number): 1 | 2 | 3 {
  if (accuracy >= 90) return 3;
  if (accuracy >= 75) return 2;
  return 1;
}

export function computeCoinsAwarded(score: number, stars: 1 | 2 | 3): number {
  return Math.round(score / 50) + stars * 10;
}
